/**
 * Discount exclusion configuration.
 *
 * Products listed here will display an exclusion message on the PDP.
 *
 * To exclude a product, add its numeric product ID to the relevant range below.
 * Each range is a named grouping for readability — all ranges are merged into a
 * single lookup set at runtime.
 *
 * Example:
 *   const SUMMER_COLLAB_RANGE = [123456, 789012];
 */

// ---------------------------------------------------------------------------
// Define excluded ranges here
// ---------------------------------------------------------------------------

const ALL_EXCLUDED_RANGES: readonly number[][] = [];

// ---------------------------------------------------------------------------
// Merged lookup set — do not edit below this line
// ---------------------------------------------------------------------------

export const DISCOUNT_EXCLUDED_PRODUCT_IDS = new Set<number>(
  ALL_EXCLUDED_RANGES.flat(),
);

// ---------------------------------------------------------------------------
// Per-product purchase quantity limits
//
// Products listed here cannot be added to the bag beyond the specified limit.
// The limit is enforced client-side only.
//
// Example:
//   export const PRODUCT_QUANTITY_LIMITS: Record<number, number> = {
//     123456: 2,
//   };
// ---------------------------------------------------------------------------

const TOLU_COKER_RANGE = [
  209527279, 209605148, 209639400, 209547709, 209547866, 209776302, 209508939,
  209508965, 209605537, 209605109, 209605664, 209542936, 209554232, 210346021,
  210346095, 209508909, 209844243, 209547661,
];

export const PRODUCT_QUANTITY_LIMITS: Record<number, number> =
  Object.fromEntries(TOLU_COKER_RANGE.map((id) => [id, 4]));
